export default __webpack_public_path__ + "static/media/chi-flat.92ab8daa.png";